// Rama publiczna paczki 37 — stopka (artboardy 01, 02, 03a–03c; runda R3).
//
// TRZY GRUPY z nagłówkami: Produkt / Pomoc / Prawne, a po lewej lockup z PL/EN.
// Jedna linia z pięcioma linkami (R2) skończyła się tam, gdzie kończy się każda
// jedna linia: nie mieściła drogi do konta ani nazwy sprzedawcy, a nazwy dokumentów
// musiała skracać do jednego słowa. Grupa nazywa, czego szuka czytelnik, zanim
// przeczyta link — i dopiero wtedy „Polityka prywatności” może stać pod pełną nazwą.
//
// „Zgłoś treść” (art. 16 DSA) stoi tu na KAŻDEJ stronie publicznej — posiadacz praw
// trafia na stronę główną, nie na zakładkę prawną. To jeden z powodów, dla których ta
// stopka nie ma wariantu „krótszego”.
//
// Gość i klient nie dostają tej samej propozycji (ta sama zasada, co w nagłówku):
// zalogowanemu grupa „Produkt” pokazuje drogę POWROTNĄ do editów, nie dwa wejścia.
//
// 390: grupy jedna pod drugą (cel 44 px), a lockup z PL/EN schodzi na sam dół.

import { Link } from 'react-router'
import { useAuthOptional } from '../../auth/AuthContext'
import LangSwitcher from '../LangSwitcher'
import Logo from '../Logo'
import { useT } from '../../lib/i18n'
import { usePublicPath } from '../../lib/publicPaths'
import '../../styles/minimal-public.css'

export default function PublicFooterBar() {
  const t = useT()
  const pub = usePublicPath()
  // Opcjonalnie: 404 gościa renderuje się poza <AuthProvider> (LocaleRoute i testy),
  // a stopka, która tam rzuca, kładzie całą stronę.
  const user = useAuthOptional()?.user ?? null

  return (
    <footer className="mp-foot">
      <div className="mp-foot-brand">
        <Link to={pub()} className="logo" aria-label="EDIMI"><Logo size={20} /></Link>
        <LangSwitcher variant="segments" />
      </div>

      <nav className="mp-foot-grp" aria-label={t('landing.footer.groupProduct')}>
        <b className="mp-foot-h">{t('landing.footer.groupProduct')}</b>
        <Link className="mp-nav-link" to={pub('/pricing')}>{t('landing.footer.cennik')}</Link>
        <Link className="mp-nav-link" to={pub('/faq')}>{t('landing.footer.faq')}</Link>
        {user ? (
          <Link className="mp-nav-link" to="/edits">{t('landing.nav.toPanel')}</Link>
        ) : (
          <>
            <Link className="mp-nav-link" to="/login">{t('landing.footer.login')}</Link>
            <Link className="mp-nav-link" to="/register">{t('landing.nav.startFree')}</Link>
          </>
        )}
      </nav>

      <nav className="mp-foot-grp" aria-label={t('landing.footer.groupHelp')}>
        <b className="mp-foot-h">{t('landing.footer.groupHelp')}</b>
        <a className="mp-nav-link" href="mailto:kontakt@edimi.ai">{t('landing.footer.contact')}</a>
        <Link className="mp-nav-link" to={pub('/zwroty')}>{t('landing.footer.refunds')}</Link>
        <Link className="mp-nav-link" to={pub('/zgloszenie')}>{t('landing.footer.report')}</Link>
      </nav>

      <nav className="mp-foot-grp" aria-label={t('landing.footer.groupLegal')}>
        <b className="mp-foot-h">{t('landing.footer.groupLegal')}</b>
        <Link className="mp-nav-link" to={pub('/regulamin')}>{t('landing.footer.terms')}</Link>
        <Link className="mp-nav-link" to={pub('/polityka')}>{t('landing.footer.privacyFull')}</Link>
        {/* Kto sprzedaje — jedna z trzech rzeczy, których szuka operator płatności. */}
        <span className="mp-foot-seller">{t('landing.footer.seller')}</span>
      </nav>
    </footer>
  )
}
